import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { mutation as removeTagMutation, buildVariables as buildRemoveVariables } from './remove-tag-mutation-builder';

import { TAGS_WITH_PIPELINE_COUNT_QUERY } from '../tags-with-pipeline-count-query-builder';
import { TAGS_QUERY } from '../useQueryTags';

export default function useRemoveTag(options = {}) {
  const [executeMutation, response] = useMutation(removeTagMutation, {
    context: { permission: permissions.writeTags },
    successMsg: 'Tag deleted.',
    refetchQueries: [TAGS_WITH_PIPELINE_COUNT_QUERY, TAGS_QUERY],
    ...options,
  });

  const removeTag = ({ tag }) => {
    return executeMutation(buildVariables({ tag }));
  };

  return [removeTag, response];
}

function buildVariables({ tag }) {
  return {
    variables: buildRemoveVariables({ id: tag.id }),
  };
}
